export function settingService(http) {

    return {
        async getByteArray(controller, action, option) {
            return await http.get(`${controller}${action}`, option);
        }
    }
}